import React from "react";
import '../Common.scss';
import defaultImage from '../../../assets/default.png';
import styles from './lights-overview.module.scss';
export default class LightingPlan extends React.Component<any, any>{

    render() {
        const { pageDetails } = this.props;
        //const images = pageDetails['images'][0];
        const { overviewDetails } = pageDetails || {};
        // const { elevationImage } = pageDetails || {};
        return (
            <>
                    <div className="page-heading">{pageDetails?.name}</div>
                        <div className={styles["appliances-details"]}>
                        {
                            overviewDetails && overviewDetails.length ? 
                            <div className={styles["details-table-app"]}>
                                 <div className={styles["table-row-app"]}>
                                    <div className={styles["table-cell-app"]}>
                                        {"IMAGE"}
                                    </div>
                                    <div className={styles["table-cell-app"]}>
                                        {"SUB CATEGORY"}
                                    </div>
                                    <div className={styles["table-cell-app"]}>
                                        {"PRODUCT TYPE"}
                                    </div>
                                    <div className={styles["table-cell-app"]}>
                                        {"PRODUCT SKU"}
                                    </div>
                                    <div className={styles["table-cell-app"]}>
                                        {"PRODUCT NAME"}
                                    </div>
                                    <div className={styles["table-cell-app"]}>
                                        {"BRAND"}
                                    </div>
                                    <div className={styles["table-cell-app"]}>
                                        {"WATTAGE"}
                                    </div>
                                    <div className={styles["table-cell-app"]}>
                                        {"SIZE"}
                                    </div>
                                    <div className={styles["table-cell-app"]}>
                                        {"QUANTITY"}
                                    </div>
                                    <div className={styles["table-cell-app"]}>
                                        {"VENDOR SKU"}
                                    </div>
                                    <div className={styles["table-cell-app"]}>
                                        {"COLOR TEMP"}
                                    </div>
                                </div>
                                {
                                    (overviewDetails || []).map((lights, index)=>{
                                        let {name, imageUrl, subcategory, productType, productSku, brand, wattage, size, totalCount, vendorSku, colorTemp} = lights;
                                        return(
                                            <div className={styles["table-row-app"]}>
                                                <div className={styles["table-cell-app"]}>
                                                <img alt="" crossOrigin="anonymous" src={imageUrl ? `${imageUrl.replace('https://prod.homelanestore.com','https://www.homelanestore.com')}?ver=${new Date().getTime()}` : defaultImage} width="40px" height="25px" />
                                                </div>
                                                <div className={styles["table-cell-app"]}>
                                                    {subcategory? subcategory.toString().toUpperCase(): "NA"}
                                                </div>
                                                <div className={styles["table-cell-app"]}>
                                                 {productType? productType.toString().toUpperCase(): "NA"}
                                                </div>
                                                <div className={styles["table-cell-app"]}>
                                                {`${productSku? productSku.toString().toUpperCase(): "NA"}`}
                                                </div>
                                                <div className={styles["table-cell-app"]} style={{width:"10%"}}>
                                                {`${name ? name.toString().toUpperCase() : "NA"}`}
                                                </div>
                                                <div className={styles["table-cell-app"]}>
                                                {`${brand? brand.toString().toUpperCase(): "NA"}`}
                                                </div>
                                                <div className={styles["table-cell-app"]}>
                                                {`${wattage? wattage.toString().toUpperCase(): "NA"}`}
                                                </div>
                                                <div className={styles["table-cell-app"]}>
                                                {`${size? size.toString().toUpperCase(): "NA"}`}
                                                </div>
                                                <div className={styles["table-cell-app"]} >
                                                {`${totalCount ? totalCount.toString().toUpperCase(): "NA"}`}
                                                </div>
                                                <div className={styles["table-cell-app"]}>
                                                {`${vendorSku ? vendorSku.toString().toUpperCase() : "NA"}`}
                                                </div>
                                                <div className={styles["table-cell-app"]}>
                                                {`${colorTemp ? colorTemp.toString().toUpperCase() : "NA"}`}
                                                </div>
                                            </div>
                                        )
                                    })
                                }
                            </div>: <div className={styles['emptyDiv']}>
                                <b>No Data found</b>
                            </div>
                        }
                    </div>
                </>  

        )
    }

}